import React from "react";
import LeavesPresenter from "./LeavesPresenter";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOLeaves from "./DTOLeaves";
import { useTranslation } from "react-i18next";

function LeavesController() {
  const { i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOLeaves />
        <LeavesPresenter />
      </Grid>
    </Shell>
  );
}
export default LeavesController;
